import { BehaviorSubject } from "rxjs";

export class BehaviorSubjectWithInterceptors<T> extends BehaviorSubject<T> {
  private interceptors: ((value: T) => T)[] = [];

  addInterceptor(interceptor: (value: T) => T) {
    this.interceptors.push(interceptor);
  }

  //remove
  removeInterceptor(interceptor: (value: T) => T) {
    this.interceptors = this.interceptors.filter((m) => m !== interceptor);
  }

  override next(value: T) {
    let modifiedValue = value;
    for (const interceptor of this.interceptors) {
      modifiedValue = interceptor(modifiedValue);
    }
    super.next(modifiedValue);
  }
}
